import React from "react";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { EditButton, DeleteButton } from "@refinedev/mui";

import { TableCell, ActiveStoreSwitch } from "@shared/components";
import { Company } from "@modules/companies/types";
import { Button } from "@mui/material";

export const useStoresListColumns = (
  onRefetch: () => void,
  translate: (key: string) => string,
  companies?: Company[],
): GridColDef[] => {

  const renderETCell = (params: GridRenderCellParams) => (
    <Button
      variant="outlined"
      color="primary"
      size="small"
      onClick={() =>
        window.open(
          `https://pdv.partiu.com.br/login/${params.value}`,
          "_blank"
        )
      }
    >
      Visão Logista
    </Button>
  );

  return React.useMemo<GridColDef[]>(
    () => [
      {
        field: "company",
        headerName: translate("v1/store_admin.fields.company"),
        minWidth: 250,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Link
            to={`/companies/edit/${value}`}
            value={companies?.find(company => company.id === value)?.name}
          />
        ),
      },
      {
        field: "state",
        headerName: translate("v1/store_admin.fields.state"),
        minWidth: 120,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="left"
          />
        ),
      },
      {
        field: "city",
        headerName: translate("v1/store_admin.fields.city"),
        minWidth: 120,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="left"
          />
        ),
      },
      {
        field: "neighborhood",
        headerName: translate("v1/store_admin.fields.neighborhood"),
        minWidth: 120,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="left"
          />
        ),
      },
      {
        field: "street",
        headerName: translate("v1/store_admin.fields.street"),
        minWidth: 250,
        headerAlign: "left",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            textAlign="left"
          />
        ),
      },
      {
        field: "usage",
        headerName: translate("v1/store_admin.fields.usage"),
        minWidth: 120,
        headerAlign: "center",
        renderCell: ({ value }) => (
          <TableCell.Text
            value={value}
            align="center"
          />
        ),
      },
      {
        field: "active",
        headerName: translate("v1/store_admin.fields.active"),
        minWidth: 120,
        headerAlign: "center",
        renderCell: ({ value, row }) => (
          <TableCell.Container align="center">
            <ActiveStoreSwitch value={value} id={row.id} />
          </TableCell.Container>
        ),
      },
      {
        field: "pdv_et",
        headerName: "Visão Logista",
        minWidth: 150,
        headerAlign: "center",
        renderCell: renderETCell,
      },
      {
        field: "created_at",
        headerName: translate("v1/store_admin.fields.created_at"),
        minWidth: 120,
        headerAlign: "center",
        renderCell: ({ value }) => (
          <TableCell.Date
            value={value}
          />
        ),
      },
      {
        field: "actions",
        headerName: translate("table.actions"),
        headerAlign: "center",
        minWidth: 120,
        sortable: false,
        renderCell: ({ row }) => (
          <TableCell.Container align="center">
            <EditButton
              hideText
              recordItemId={row.id}
            />
            <DeleteButton
              hideText
              recordItemId={row.id}
              onSuccess={onRefetch}
            />
          </TableCell.Container>
        ),
      },
    ],
    [translate, onRefetch, companies],
  );
};
